import type { HandlingUnitHashMap, PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import {
  isAdditionalTextEnabledForRow,
  shouldShowAdditionalTextColumn,
} from "@RequestFormV2/sections/PackingList/utils/packingListWorkflowFlags";

export type CustomFieldDisplayItem = {
  handling_unit?: string;
  additional_field?: string;
  other_instructions?: string;
  additional_field_label?: string;
};

export function getPersistedCustomFieldValue(item: CustomFieldDisplayItem): string {
  return item.additional_field?.trim() || item.other_instructions?.trim() || "";
}

export function isCustomFieldEnabledForItem(
  item: CustomFieldDisplayItem,
  handlingUnitHashMap: HandlingUnitHashMap,
): boolean {
  if (!item.handling_unit) return false;
  return isAdditionalTextEnabledForRow({ handling_unit: item.handling_unit } as PackingListRow, handlingUnitHashMap);
}

export function getCustomFieldLabel(
  item: CustomFieldDisplayItem,
  handlingUnitHashMap: HandlingUnitHashMap,
): string | undefined {
  const fromItem = item.additional_field_label?.trim();
  if (fromItem) return fromItem;

  const handlingUnit = item.handling_unit?.toLowerCase();
  if (!handlingUnit) return undefined;

  const fromSettings = handlingUnitHashMap[handlingUnit]?.additional_field_label?.trim();
  return fromSettings || undefined;
}

export function shouldShowCustomFieldColumn(
  items: CustomFieldDisplayItem[],
  handlingUnitHashMap: HandlingUnitHashMap,
): boolean {
  const handlingUnitRows = items
    .filter((item) => item.handling_unit?.toLowerCase() !== "container")
    .map((item) => ({
      handling_unit: item.handling_unit ?? "",
      additional_field: getPersistedCustomFieldValue(item),
    }));

  return (
    shouldShowAdditionalTextColumn(handlingUnitRows, handlingUnitHashMap) ||
    items.some((item) => getPersistedCustomFieldValue(item).length > 0)
  );
}

export function formatCustomFieldDisplayValue(value: string): string {
  return value || "-";
}
